import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addlocation',
  templateUrl: './addlocation.component.html',
  styleUrls: ['./addlocation.component.css']
})
export class AddlocationComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname:String="Location"; 
 
//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;
//Edit Get Values
locationColl:any=[];
locationBO:any={};

locationid:number=0

locationform=new FormGroup({
  locationid:new FormControl(0),          
  locationname:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


@Input() ischild :boolean=false;
@Input() ischildadd :boolean=false;
@Input() ischildkey :number=0
@Output() childChanged = new EventEmitter<number>();



constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.locationid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.locationform.reset();
       this.fnInitializeFormGroup(); 

       if(this.locationid>0){
         this.fngetLocation();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.locationid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.locationform.setValue({
    locationid:0,    
    locationname:'',
     inactive:false              
   })
}

//Get 
fngetLocation() { 
  if (this.showProgress) {
    return;
  }         
     var data = {
       'locationid':this.locationid,
       'companyid':this.loginService.fnGetCompanyId() 
      
     }
     this.appService.getLocation(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){  
          this.fnHideProgress();

           this.locationColl=res.json().result;
           var editdata = this.locationColl[0];        
           this.fnEditMode(editdata);
           this.locationBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{    
      this.fnHideProgress();
      
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
 
   try{
    if (this.saveloading) {
           return;
         }
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.locationform.valid){this.saveloading = true;
         //Check
         var data = {
               'locationid': this.locationid,                      
               'locationname':this.locationform.get('locationname').value, 
               'inactive':this.locationform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckLocation(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.locationform.get('locationid').value>0){
                       //Update 
                       this.fnSetLocation(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertLocation(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.locationform.controls['locationname'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertLocation(data){    
 
   this.appService.fnInsertLocation(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
        
           this.toastr.success('', "The new location has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.locationname);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetLocation(data){    

this.appService.fnSetLocation(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The location has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.locationid,data.locationname);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  
  if(this.ischild===false){
    this.router.navigate(['/Location']);
  }
  else{
    var pBO:any={
      isadd:this.ischildadd,
      childkey:this.ischildkey,
      doctype:'LOCATION'    
    }
    this.childChanged.emit(pBO);
  }

}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.locationform.setValue({ 
  locationid:deptBO.locationid,     
  locationname:deptBO.locationname,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}








}
